function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import * as EditorContext from "../EditorContext";
import ScrollArea from "react-scrollbar";

var ScriptText = function (_React$Component) {
  _inherits(ScriptText, _React$Component);

  function ScriptText() {
    _classCallCheck(this, ScriptText);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ScriptText.prototype.render = function render() {
    var EditorContext = this.props.EditorContext;
    var scriptText = EditorContext.state.scriptText;
    return scriptText ? React.createElement(ScrollArea, {
      speed: 0.8,
      className: "area",
      contentClassName: "content",
      horizontal: false,
      style: {
        width: "16%",
        color: "#FFF",
        fontSize: 26,
        position: "absolute",
        right: 50,
        top: 100,
        bottom: 100,
        zIndex: 10
      },
      contentStyle: {
        paddingRight: 10
      },
      verticalScrollbarStyle: {
        backgroundColor: "#FFF"
      }
    }, React.createElement("div", null, scriptText)) : null;
  };

  return ScriptText;
}(React.Component);

ScriptText.propTypes = process.env.NODE_ENV !== "production" ? {
  EditorContext: PropTypes.object.isRequired
} : {};
export default EditorContext.consumeContext(ScriptText);